/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components'

import { GeneralSection } from '../../general/index';
import { InsurerTaxesSection } from '../index';
import { FeePayableBySection } from '../../feePayableBy/index';

function RenderSection({
  disableAll,
  values,
  setFieldValue,
  errors,
  setFieldError,
  formikRef,
  idOperation,
  idOperationParent,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  insurerGroup,
  feePayableByGroup,
  setFeePayableByGroup,
  setInsurerGroup,
  insurersTaxes,
  isGrouped,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <>
      {insurerGroup.map((questions, index) => (
        <FormSection
          key={index}
          sectionIndex={index}
          sectionName="INSURER_TAXES"
          formikRef={formikRef}
          disableAll={disableAll}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          questionnaire={questions}
          setQuestionnaire={(questionnaire) => setInsurerGroup(insurerGroup.map((v, i) => i === index ? questionnaire : v))}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
          ignoreModality
          replaceQuery={
            isGrouped
              ? [
                { searchQueryId: "getFacilities", values: [{ id: -1, value: "All" }] },
                { searchQueryId: "getInsurers", values: [{ id: -1, value: "All" }] },
              ]
              : null
          }
          onQuestionChange={(
            question,
            value,
            setFieldValue,
            questionnaireUpdated
          ) =>
            InsurerTaxesSection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaireUpdated: (questionnaire) => setInsurerGroup(insurerGroup.map((v, i) => i === index ? questionnaire : v)),
              setFieldValue,
              insurerGroup,
              insurerGroupUpdated: insurerGroup.map((group, i) => i === index ? questionnaireUpdated : group),
              feePayableByGroup,
              setFeePayableByGroup,
              questionnaireAnswersToDelete,
              setQuestionnaireAnswersToDelete,
            })
          }
          onBlur={(
            question,
          ) =>
            InsurerTaxesSection.events.handleQuestionBlur({
              question,
              insurerGroup,
              feePayableByGroup,
              setFeePayableByGroup,
            })
          }
          extraButtons={() => {
            const isValidToRenderButtons = InsurerTaxesSection.events.validateRenderButtons({
              questions,
              isGrouped,
              insurersTaxes,
            });

            if (!isValidToRenderButtons) {
              return GeneralSection.components.RenderSectionAddAndRemoveRowButtons({
                partySectionName: "$ANSWERS_INSURER_TAXES_0",
                sectionState: insurerGroup,
                setSectionState: setInsurerGroup,
                index,
                questions,
                questionnaireAnswersToDelete,
                setQuestionnaireAnswersToDelete,
                onRemove: (newInsurerGroup, updatedQuestionnaireAnswersToDelete) => FeePayableBySection.events.handleGroup({
                  insurerGroup: newInsurerGroup,
                  feePayableByGroup,
                  setFeePayableByGroup,
                  questionnaireAnswersToDelete: updatedQuestionnaireAnswersToDelete,
                  setQuestionnaireAnswersToDelete,
                })
              });
            } else if (insurerGroup.length - 1 == index) {
              return GeneralSection.components.RenderSectionAddRowButton({
                sectionState: insurerGroup,
                setSectionState: setInsurerGroup,
                questions,
              })
            }
          }}
        />
      ))}
    </>
  )
}

const components = {
  RenderSection
}

export { components }